// src/utils/camera.js — Utilitário de câmera compartilhado

/**
 * Abre a câmera com fallback robusto.
 * Enumera dispositivos disponíveis antes de tentar abrir.
 */
export async function abrirCamera() {
  // Verifica se API existe
  if (!navigator.mediaDevices?.getUserMedia) {
    throw new Error("Seu navegador não suporta acesso à câmera.");
  }

  // Enumera dispositivos de vídeo disponíveis
  let videoDevices = [];
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    videoDevices = devices.filter(d => d.kind === "videoinput");
  } catch { /* ignora erro de enumeração */ }

  // Se nenhuma câmera encontrada
  if (videoDevices.length === 0) {
    // Tenta abrir sem restrições mesmo assim (alguns browsers ocultam antes de conceder permissão)
    return await navigator.mediaDevices.getUserMedia({ video: true });
  }

  // Tenta abrir por deviceId (mais confiável que facingMode em notebooks)
  // Prefere câmera traseira se disponível, senão usa a primeira
  const backCamera = videoDevices.find(d =>
    d.label.toLowerCase().includes("back") ||
    d.label.toLowerCase().includes("rear") ||
    d.label.toLowerCase().includes("traseira") ||
    d.label.toLowerCase().includes("environment")
  );

  const targetDevice = backCamera || videoDevices[0];

  if (targetDevice?.deviceId) {
    try {
      return await navigator.mediaDevices.getUserMedia({
        video: { deviceId: { exact: targetDevice.deviceId } }
      });
    } catch { /* fallback */ }
  }

  // Último recurso: sem nenhuma restrição
  return await navigator.mediaDevices.getUserMedia({ video: true });
}

/**
 * Captura um frame da câmera como base64 JPEG.
 */
export function capturarFoto(video, mimeType = "image/jpeg", quality = 0.85) {
  const canvas = document.createElement("canvas");
  canvas.width  = video.videoWidth  || 640;
  canvas.height = video.videoHeight || 480;
  canvas.getContext("2d").drawImage(video, 0, 0);
  return canvas.toDataURL(mimeType, quality);
}

/**
 * Para todos os tracks de um MediaStream.
 */
export function pararCamera(stream) {
  if (stream) stream.getTracks().forEach(t => t.stop());
}
